export const webHosting = {
  title: 'Web Hosting',
  description: 'Piani hosting DirectAdmin con storage NVMe, protezione DDoS e SSL gratuito.',
  features: {
    performance: {
      title: 'Prestazioni',
      description: 'NVMe SSD super veloci'
    },
    security: {
      title: 'Sicurezza',
      description: 'Certificato SSL incluso'
    },
    backup: {
      title: 'Backup',
      description: 'Backup giornalieri automatici'
    },
    support: {
      title: 'Supporto 24/7',
      description: 'Assistenza dedicata sempre attiva'
    }
  },

  plans: {
    starter1: {
      title: 'Starter 1',
      price: '€1.99',
      specs: [
        '1GB RAM',
        '2GB NVMe SSD',
        '1 Sito',
        'Backup: Non incluso',
        'SSL: Incluso'
      ]
    },
    starter2: {
      title: 'Starter 2',
      price: '€3.99',
      specs: [
        '2GB RAM',
        '5GB NVMe SSD',
        '3 Siti',
        'Backup: Non incluso',
        'SSL: Incluso'
      ]
    },
    starter3: {
      title: 'Starter 3',
      price: '€6.99',
      specs: [
        '3GB RAM',
        '10GB NVMe SSD',
        '5 Siti',
        'Backup: Non incluso',
        'SSL: Incluso'
      ]
    },

    advanced1: {
      title: 'Advanced 1',
      price: '€14.99',
      specs: [
        '4GB RAM',
        '100GB NVMe SSD',
        '10 Siti',
        'Backup: Incluso',
        'SSL: Incluso'
      ]
    },
    advanced2: {
      title: 'Advanced 2',
      price: '€24.99',
      specs: [
        '6GB RAM',
        '150GB NVMe SSD',
        '15 Siti',
        'Backup: Incluso',
        'SSL: Incluso'
      ]
    },
    advanced3: {
      title: 'Advanced 3',
      price: '€49.99',
      specs: [
        '12GB RAM',
        '300GB NVMe SSD',
        '30 Siti',
        'Backup: Incluso',
        'SSL: Incluso'
      ]
    }
  }
};
